import axiosInstance from "./AxiosInstance";

const businessSummaryService = {
  submitBusinessSummary: (data) => {
    const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
      ?.token;
    return axiosInstance({
      url: "/api/specialized-clinic-value",
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    });
  },

  // Get business summary by ID
  getBusinessSummary: (id) => {
    const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
      ?.token;
    return axiosInstance({
      url: `/api/business-summary/${id}`,
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  updateBusinessSummary: (id, data) => {
    const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
      ?.token;
    return axiosInstance({
      url: `/api/specialized-clinic-value`,
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    });
  },
};

export default businessSummaryService;
